//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class RuleExpressionModel extends ModelBase {
      static readonly $typeName = 'RuleExpressionModel';
      public key: string;
      public comparePropertyKey: string;
      public compareTypeName: string;
      public compareValue1: string;
      public compareVocabulary: LookupModel;
      public compareValue2: string;
      public errorMessage: string;
      public compareDataLinkKey: string;
      public linkedFieldName: string;
      public operationName: string;
      public propertyKey: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/RuleExpressionModel.ts